export default __webpack_public_path__ + "static/luxury-real-estate-bg-c9b1ee03e60c806b2920eb2869b9618d.jpeg";